import { AREA, DataSecurityLevel, EVENT_CATEGORY, EVENT_NAME, FEATURE_DETAILS, FIELD_NAME_SEPARATOR, PAGE_APP_NAME, PAGE_NAME, PAGE_TYPE, SUB_AREA, } from '@office-start/telemetry-types';
import { convertRouteToPage, filterPii, getFlattenedFieldName, getPageAppName, getPageType, } from '@office-start/telemetry-utility';
import { getCurrentRouteItem, isRouteInitialized, logEvent, } from '../TelemetryService';
/**
 *  Logs feature team related custom event with given properties.
 *  All events belong to the feature will be stored into single Kusto table `Office.Taos.Hub.Feature.(FeatureName)`.
 *
 *  Feature events will logged in short-term Kusto storage and long term data store such as COSMOS considering the need to create scorecard by partner team or customized PowerBI dashboard.
 *  Like Diagnostic events,this type of events provides flexibility for developers that event may contain unexpected values that sometimes exceed the allowed System Metadata
 *  or EUPI classifications for our telemetry -- resulting in a potential privacy event which will force whole table to be shut down and that's why we decide to have feature team specific bucket
 *  in order to not impact other feature team's events. Feature team will own the tagging of COSMOS data and dashboard for this type of event.
 *
 *  @param properties Properties pertaining to feature event
 *                    - featureName: KnownFeatureNames;
 *                    - eventName: string;
 *                    - params: { [param: string]: string | number | boolean };
 *                      [NOTE] The key should be `PascalCased`.
 *  @param securityThreshold DataSecurityLevel corresponds to Windows PlatformDataCollectionLevel which are ignored outside UWP.
 *
 * Event naming convention: Office.Taos.Hub.Feature.(FeatureName)
 *
 * e.g.
 *     const featureParams = {};
 *     featureParams['Index'] = 5;
 *     featureParams['RenderSize'] = '200';
 *
 *     logFeature(
 *          {
 *              featureName: KnownFeatureNames.Search,
 *              eventName: 'SearchQuery',
 *              params: featureParams,
 *              area: 'Edgeworth',
 *         }
 *      );
 */
export function logFeature(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logEvent(createEventName(properties.featureName), generateFeatureParams(properties), securityThreshold);
}
export function generateFeatureParams(properties) {
    var _a, _b;
    var params = {};
    for (var key in properties.params) {
        params[getFlattenedFieldName([FEATURE_DETAILS, key])] =
            typeof properties[key] === 'string'
                ? filterPii(properties.params[key])
                : properties.params[key];
    }
    params[EVENT_CATEGORY] = "Feature" /* EventCategory.Feature */;
    params[EVENT_NAME] = properties.eventName;
    if (isRouteInitialized()) {
        var pageName = convertRouteToPage(getCurrentRouteItem());
        params[getFlattenedFieldName([FEATURE_DETAILS, PAGE_NAME])] = pageName;
        params[getFlattenedFieldName([FEATURE_DETAILS, PAGE_TYPE])] = getPageType(pageName);
        params[getFlattenedFieldName([FEATURE_DETAILS, PAGE_APP_NAME])] = getPageAppName(pageName);
    }
    params[getFlattenedFieldName([FEATURE_DETAILS, AREA])] =
        (_a = properties.area) !== null && _a !== void 0 ? _a : '';
    params[getFlattenedFieldName([FEATURE_DETAILS, SUB_AREA])] =
        (_b = properties.subArea) !== null && _b !== void 0 ? _b : '';
    return params;
}
export function createEventName(feature) {
    return ["Feature" /* EventCategory.Feature */, feature].join(FIELD_NAME_SEPARATOR);
}
//# sourceMappingURL=logFeature.js.map